import { get, post, put } from './utils';


export async function getCurrentUserApi(userId) {
    return get(`users${userId}`);
}

export async function loginApi(data) {
    return post(`/auth/login`, data);
}

export async function registerApi(data) {
    return post(`/auth/signup`, data);
}

export async function forgotPasswordApi(data) {
    return put(`/auth/forgot-password`, data);
}

export async function resetPasswordApi(data) {
    return put(`/auth/reset-password`, data);
}

export async function changePasswordApi(data) {
    return put(`/auth/me/changePassword`, data);
}

export async function sendEmailForMFA(email) {
    return post(`/public/um/mfa/email/send?email=${encodeURIComponent(email)}`);
}